module.exports = "/images/22ed06c8eadd0dc6f37f9c52b9a4dee8.png";